import React, { useState, useEffect } from "react";
import { Card, CardHeader, CardTitle, CardContent } from "../ui/card";

interface ClockWidgetProps {
  id: string;
  title: string;
}

const ClockWidget: React.FC<ClockWidgetProps> = ({ title }) => {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <Card>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="text-4xl font-bold text-center">
          {time.toLocaleTimeString()}
        </div>
        <div className="text-sm text-muted-foreground text-center mt-2">
          {time.toLocaleDateString()}
        </div>
      </CardContent>
    </Card>
  );
};

export default ClockWidget; 